export default __webpack_public_path__ + "static/client-communication-bd444170b76c167583ceac5273b4a1bd.png";